import React, { FC, useRef, KeyboardEvent, useEffect } from 'react'
import FocusAreaDialog from './FocusAreaDialog'
import { Tour } from '../Popover.types'
import '../css/FocusArea.scss'

type FocusAreaProps = {
  top: string
  left: string
  width: string
  height: string
  dialogPosition: string
  children: React.ReactNode
  tour: Tour
  index: number
}

const FocusArea: FC<FocusAreaProps> = props => {
  const {
    tour: { currentFocusArea, setCurrentFocusArea },
    dialogPosition,
    children,
    top,
    left,
    height,
    width,
    index,
  } = props
  const focusAreaDialogCloseButton = useRef<HTMLButtonElement>(null)
  const focusAreaRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (currentFocusArea !== index) {
      return
    }
    // Check for Internet Explorer
    const ua = window.navigator.userAgent.toLowerCase()
    // IE user-agent strings contain "MSIE" and/or "Trident" (code name for IE's rendering engine)
    const _isIE = ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1
    const scrollElement = _isIE ? focusAreaDialogCloseButton : focusAreaRef
    scrollElement?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    })
  }, [currentFocusArea])

  useEffect(() => {
    if (currentFocusArea !== index) {
      return
    }
    const handleClick = (event: MouseEvent) => {
      if (focusAreaRef?.current?.contains(event.target as Node)) {
        return
      }
      setCurrentFocusArea(null)
    }
    window.addEventListener('click', handleClick)
    return () => {
      window.removeEventListener('click', handleClick)
    }
  }, [currentFocusArea])

  const handleClick = () => {
    setCurrentFocusArea(index)
  }
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key !== 'Escape') {
      return
    }
    setCurrentFocusArea(null)
  }
  const style = {
    top: `${top}%`,
    left: `${left}%`,
    width: `${width}%`,
    height: `${height}%`,
  }

  return (
    <div
      className={`FocusArea u-sm-hidden${currentFocusArea === index ? ' active' : ''}`}
      ref={focusAreaRef}
      onKeyDown={handleKeyDown}
      style={style}>
      <button className='FocusAreaButton' onClick={handleClick}>
        <span className='u-hiddenVisually'>Open Dialog</span>
      </button>
      <span className='FocusAreaIndicator pulse'></span>
      <FocusAreaDialog
        focusAreaDialogCloseButtonRef={focusAreaDialogCloseButton}
        active={currentFocusArea === index}
        position={dialogPosition}
        index={index}
        tour={props.tour}>
        {children}
      </FocusAreaDialog>
    </div>
  )
}
export default FocusArea
